var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@iconify/react';
import { Alert, Autocomplete, Box, CircularProgress, FormControl, FormHelperText, Grid, TextField, Typography } from '@mui/material';
import { Fragment, useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FileErrorType } from '../../../../application/common/enums/file-error-type';
import { useLazyGetModelNumbersByMachinesQuery } from '../../../../application/features/machines/machine-api';
import useTranslate from '../../../../localization/helpers';
import MultipleFileUpload from '../../../components/MultipleFileUpload';
import PublicPrivateToggle from '../../../components/PublicPrivateToggle';
var AddDocuments = function (_a) {
    var machines = _a.machines, filteredMachines = _a.filteredMachines, _b = _a.initialFiles, initialFiles = _b === void 0 ? [] : _b, onFileError = _a.onFileError;
    var _c = useTranslate(), translate = _c.translate, tWithField = _c.tWithField;
    var _d = __read(useState('Public'), 2), visibilityMode = _d[0], setVisibilityMode = _d[1];
    var _e = __read(useState({}), 2), fileVisibility = _e[0], setFileVisibility = _e[1];
    var _f = __read(useState({
        hasError: false,
        errorType: FileErrorType.NoError
    }), 2), fileError = _f[0], setFileError = _f[1];
    var _g = __read(useLazyGetModelNumbersByMachinesQuery(), 2), getMachineModels = _g[0], _h = _g[1], _j = _h.data, modelNumbers = _j === void 0 ? [] : _j, modelNumbersFetcing = _h.isFetching;
    var _k = useFormContext(), control = _k.control, setValue = _k.setValue, watch = _k.watch, errors = _k.formState.errors;
    var selectedMachine = watch('machineId');
    var files = watch('files');
    // Initialize form with uploaded files
    useEffect(function () {
        if (initialFiles && initialFiles.length > 0) {
            var isPublic_1 = visibilityMode === 'Public';
            var formattedFiles = initialFiles.map(function (file) { return ({
                file: file,
                isDownloadable: false,
                isPublic: isPublic_1
            }); });
            setValue('files', formattedFiles);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialFiles]);
    useEffect(function () {
        if (selectedMachine)
            getMachineModels([selectedMachine]);
    }, [getMachineModels, machines, selectedMachine]);
    // Update visibilityMode based on files state - only when files change from user actions
    useEffect(function () {
        if (files && files.length > 0) {
            var publicCount = files.filter(function (f) { return f.isPublic; }).length;
            var privateCount = files.length - publicCount;
            if (publicCount === files.length) {
                setVisibilityMode('Public');
            }
            else if (privateCount === files.length) {
                setVisibilityMode('Private');
            }
            else {
                setVisibilityMode(null); // Mixed state
            }
        }
        // Don't reset to 'Public' when files are empty - preserve user's selection
    }, [files]);
    var handleFileVisibilityChange = function (fileName, isPublic) {
        setFileVisibility(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[fileName] = isPublic, _a)));
        });
        // Update the files array with the new isPublic value
        var currentFiles = watch('files') || [];
        var updatedFiles = currentFiles.map(function (fileData) {
            return fileData.file.name === fileName ? __assign(__assign({}, fileData), { isPublic: isPublic }) : fileData;
        });
        setValue('files', updatedFiles);
    };
    return (_jsx(Box, { component: 'form', noValidate: true, autoComplete: 'off', sx: { overflowY: 'auto' }, children: _jsxs(Grid, { container: true, gap: 2, px: 1.5, mt: 1, children: [_jsx(Grid, { size: { xs: 12, md: 12, sm: 12, lg: 12 }, children: _jsx(Controller, { name: 'machineId', control: control, rules: {
                            required: {
                                value: true,
                                message: tWithField('validations.fieldIsRequired', 'common.asset')
                            }
                        }, render: function (_a) {
                            var _b, _c, _d;
                            var _e = _a.field, onChange = _e.onChange, value = _e.value;
                            return (_jsxs(FormControl, { fullWidth: true, variant: 'outlined', children: [_jsx(Autocomplete, { noOptionsText: translate('common.noOptions'), sx: {
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '8px'
                                            }
                                        }, options: machines, isOptionEqualToValue: function (option, value) { return option.id === value.id; }, getOptionLabel: function (option) { return option.name; }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { variant: 'outlined', fullWidth: true, label: translate('common.asset'), error: !!errors.machineId }))); }, value: (_b = machines.find(function (machine) { return machine.id === value; })) !== null && _b !== void 0 ? _b : null, onChange: function (_, selectedOption) {
                                            var _a;
                                            onChange((_a = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.id) !== null && _a !== void 0 ? _a : '');
                                            setValue('modelNumber', '');
                                        }, renderOption: function (props, option) { return (_createElement("li", __assign({}, props, { key: option.id }), option.name)); } }), ((_c = errors.machineId) === null || _c === void 0 ? void 0 : _c.message) && (_jsx(FormHelperText, { error: true, children: (_d = errors.machineId) === null || _d === void 0 ? void 0 : _d.message }))] }));
                        } }) }), _jsx(Grid, { size: { xs: 12, md: 12, sm: 12, lg: 12 }, children: _jsx(Controller, { name: 'modelNumber', control: control, render: function (_a) {
                            var _b = _a.field, onChange = _b.onChange, value = _b.value;
                            return (_jsx(FormControl, { fullWidth: true, variant: 'outlined', children: _jsx(Autocomplete, { sx: {
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '8px'
                                        }
                                    }, clearOnEscape: false, disableClearable: !value, loading: modelNumbersFetcing, disabled: !selectedMachine, options: modelNumbers, isOptionEqualToValue: function (option, value) { return option === value; }, renderInput: function (params) {
                                        var _a;
                                        return (_jsx(TextField, __assign({}, params, { variant: 'outlined', fullWidth: true, label: translate('common.modelNumber'), slotProps: {
                                                input: __assign(__assign({}, params.InputProps), { endAdornment: (_jsxs(Fragment, { children: [modelNumbersFetcing ? (_jsx(CircularProgress, { color: 'inherit', size: 20 })) : null, (_a = params.InputProps) === null || _a === void 0 ? void 0 : _a.endAdornment] })) })
                                            } })));
                                    }, value: value, onChange: function (_, newValue) {
                                        onChange(newValue);
                                        if (newValue && !modelNumbers.includes(newValue)) {
                                            setValue('modelNumberCreated', true);
                                        }
                                        else {
                                            setValue('modelNumberCreated', false);
                                        }
                                    }, renderOption: function (props, option) { return (_createElement("li", __assign({}, props, { key: option }), modelNumbers.includes(option) ? (_jsx("span", { children: option })) : (_jsxs("span", { children: [_jsx("strong", { children: translate('actions.add') }), " ", "\"".concat(option, "\"")] })))); }, filterOptions: function (options, params) {
                                        var inputValue = params.inputValue;
                                        var filtered = options.filter(function (o) { return o.includes(inputValue); });
                                        var isExisting = options.includes(inputValue);
                                        if (inputValue !== '' && !isExisting) {
                                            filtered.push(inputValue);
                                            setValue('modelNumberCreated', true);
                                        }
                                        return filtered;
                                    } }) }));
                        } }) }), _jsx(Grid, { size: { xs: 12 }, children: _jsx(PublicPrivateToggle, { value: visibilityMode, onChange: function (newValue) {
                            var e_1, _a;
                            setVisibilityMode(newValue);
                            var isPublic = newValue === 'Public';
                            // Update all files' isPublic property
                            var currentFiles = watch('files') || [];
                            var updatedFiles = currentFiles.map(function (fileData) { return (__assign(__assign({}, fileData), { isPublic: isPublic })); });
                            setValue('files', updatedFiles);
                            // Update fileVisibility state for all files
                            var newFileVisibility = {};
                            try {
                                for (var currentFiles_1 = __values(currentFiles), currentFiles_1_1 = currentFiles_1.next(); !currentFiles_1_1.done; currentFiles_1_1 = currentFiles_1.next()) {
                                    var fileData = currentFiles_1_1.value;
                                    newFileVisibility[fileData.file.name] = isPublic;
                                }
                            }
                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
                            finally {
                                try {
                                    if (currentFiles_1_1 && !currentFiles_1_1.done && (_a = currentFiles_1.return)) _a.call(currentFiles_1);
                                }
                                finally { if (e_1) throw e_1.error; }
                            }
                            setFileVisibility(newFileVisibility);
                        }, variant: 'inherit', size: 'large', firstLabel: translate('documents.allPublic'), secondLabel: translate('documents.allPrivate') }) }), (fileError.errorType === FileErrorType.SizeError ||
                    fileError.errorType === FileErrorType.TotalSizeError) && (_jsx(Grid, { size: { xs: 12 }, children: _jsx(Alert, { severity: 'warning', variant: 'standard', icon: _jsx(Icon, { icon: 'eva:alert-triangle-fill' }), sx: {
                            borderRadius: '14px',
                            alignItems: 'flex-start',
                            '& .MuiAlert-message': {
                                width: '100%'
                            }
                        }, children: _jsx(Typography, { variant: 'body2', children: translate('knowledge.uploadFilesDialog.publicPrivateWarning') }) }) })), _jsx(Grid, { size: { sm: 12, xs: 12, md: 12, lg: 12 }, children: _jsx(Controller, { name: 'files', control: control, rules: {
                            validate: {
                                required: function (value) {
                                    return (value && value.length > 0) ||
                                        tWithField('validations.fieldIsRequired', 'knowledge.file');
                                },
                                checkFileError: function () {
                                    return fileError.errorType === FileErrorType.CorruptedError && files.length > 0
                                        ? true
                                        : !fileError.hasError;
                                }
                            }
                        }, render: function (_a) {
                            var _b;
                            var onChange = _a.field.onChange;
                            return (_jsx(FormControl, { variant: 'outlined', fullWidth: true, children: _jsx(MultipleFileUpload, { onChange: function (files) {
                                        onChange(files);
                                    }, onValidationError: function (hasError, errorType) {
                                        setFileError({ hasError: hasError, errorType: errorType });
                                        if (onFileError) {
                                            onFileError(hasError, errorType);
                                        }
                                    }, allowedFileTypes: ['PDF'], allowedFileTypesText: 'PDF', allowedFileSize: 100, allowedTotalFileSize: 100, uploadLabel: translate('knowledge.uploadFile'), error: (_b = errors.files) === null || _b === void 0 ? void 0 : _b.message, showPublicPrivateToggle: true, fileVisibility: fileVisibility, onFileVisibilityChange: handleFileVisibilityChange, files: files, defaultIsPublic: visibilityMode === 'Public' }) }));
                        } }) })] }) }));
};
export default AddDocuments;
